import { Category } from '@/types/types';

export const categories: Category[] = [
	{
		id: 'd0f0f8b8-6d58-4eae-9e19-6f8eebd61e8c',
		number: '1',
		name: 'Grundsätzliche Verhaltensregeln',
		isFromCodeOfEthics: true,
		children: [
			{
				id: '9c512210-0b24-4b08-a284-2c54c0b0d96f',
				number: '1.1',
				name: 'Allgemeine Werbegrundsätze',
				isFromCodeOfEthics: true,
				children: [
					{
						id: 'f2d7f7c4-d7b6-4f8d-805d-c8494a2ad6f8',
						number: '1.1.1',
						name: 'Werbung soll vom Grundsatz sozialer Verantwortung geprägt sein, insbesondere gegenüber Kindern und Jugendlichen vor dem vollendeten 18. Lebensjahr.',
						isFromCodeOfEthics: true,
					},
					{
						id: '1e1f8c7b-c52d-4ae1-8b88-8ad21c6cf1a5',
						number: '1.1.2',
						name: 'Werbung muss gesetzlich zulässig sein und muss die gesetzlichen Normierungen strikt beachten.',
						isFromCodeOfEthics: true,
					},
					{
						id: '3d18f9cb-17e1-4f8c-81d6-9e4d1e3d7a1a',
						number: '1.1.3',
						name: 'Werbung muss den Grundsätzen der Lauterkeit, wie sie im Wirtschaftsleben allgemein anerkannt sind, entsprechen.',
						isFromCodeOfEthics: true,
					},
					{
						id: 'd8c8e6d6-4b76-4d18-98f9-6d2c1c8d9e7a',
						number: '1.1.4',
						name: 'Werbung darf nicht gegen die allgemein anerkannten guten Sitten verstoßen.',
						isFromCodeOfEthics: true,
					},
					{
						id: 'e2b6f7c5-1e7b-4d6c-80d9-7a2d4e3d7b8a',
						number: '1.1.5',
						name: 'Werbung darf nicht die Würde des Menschen verletzen, insbesondere durch entwürdigende oder diskriminierende Darstellungen.',
						isFromCodeOfEthics: true,
					},
					{
						id: '7c2e8f7b-1d3f-4e1d-8f6b-8a3d2f6e1d2b',
						number: '1.1.6',
						name: 'Werbung darf nicht gegen den Grundsatz der Redlichkeit und Wahrhaftigkeit verstoßen.',
						isFromCodeOfEthics: true,
					},
					{
						id: '2f8e6b4c-8d1e-4e7d-80b6-9b1c7f4d8a2c',
						number: '1.1.7',
						name: 'Werbung darf nicht durch anlehnende und nachahmende Darstellungen irreführen.',
						isFromCodeOfEthics: true,
					},
					{
						id: 'd4f1b6c8-4d6e-4e1c-80f8-7e1c2b6f8a4d',
						number: '1.1.8',
						name: 'Werbung darf das Recht auf Schutz der Privatsphäre nicht verletzen.',
						isFromCodeOfEthics: true,
					},
					{
						id: 'f8c4e1d6-2b6f-4d8a-80e7-6f1d4c7b9a2b',
						number: '1.1.9',
						name: 'Werbung muss als solche klar erkennbar sein.',
						isFromCodeOfEthics: true,
					},
					{
						id: 'b4d7e6c1-8f2e-4d1a-80c8-6f3b4d1e7a2b',
						number: '1.1.10',
						name: 'Werbung soll keinen direkten oder indirekten Kaufzwang auf KonsumentInnen ausüben.',
						isFromCodeOfEthics: true,
					},
					{
						id: 'e8d1b6f4-2c7e-4d8f-80b6-1e2d7f8a9b3c',
						number: '1.1.11',
						name: 'Werbung soll nicht auf Werbeträgern geschaltet werden, die offensichtlich österreichischen Rechtsvorschriften widersprechen.',
						isFromCodeOfEthics: true,
					},
				],
			},
			{
				id: '7e1d8c2f-4b6d-4e8f-80a1-9c3e7b6d1f2c',
				number: '1.2',
				name: 'Ethik & Moral',
				isFromCodeOfEthics: true,
				children: [
					{
						id: '6c8b1e2f-8d6e-4d7a-80f6-3b4e7f2c1d9b',
						number: '1.2.1',
						name: 'Werbung trägt soziale Verantwortung.',
						isFromCodeOfEthics: true,
					},
					{
						id: 'c8f1d7e6-2b4e-4d8a-80c7-9e1d3b6f8a4d',
						number: '1.2.2',
						name: 'Werbung hat die menschliche Würde und Unversehrtheit der Person zu achten und darf diese nicht verletzen.',
						isFromCodeOfEthics: true,
					},
					{
						id: 'f4e1d6b8-7c2e-4d8a-80f1-3b6c7e8f2d1b',
						number: '1.2.3',
						name: 'Werbung darf niemanden mittelbar oder unmittelbar diskriminieren oder Diskriminierung fördern. Besonderen Schutz vor Diskriminierung bedürfen dabei die Diversitätskerndimensionen.',
						isFromCodeOfEthics: true,
						children: [
							{
								id: '7882e998-f6fe-42a3-b799-d88fad3405a6',
								number: '1.2.3.a)',
								name: 'Alter: Werbung darf niemanden (mittelbar oder unmittelbar) aufgrund seines Alters oder seiner Generation diskriminieren. Bei älteren Menschen ist stets auf eine würdevolle Darstellung zu achten.',
								isFromCodeOfEthics: true,
							},
							{
								id: '7b2c6a4d-9c5f-4d7a-9f1b-2e3d4b5c6f7e',
								number: '1.2.3.b)',
								name: 'Geschlecht: Werbung darf niemanden (mittelbar oder unmittelbar) aufgrund seines Geschlechtes diskriminieren. Männer und Frauen sind stets als vollkommen gleichwertig zu betrachten und zu behandeln.',
								isFromCodeOfEthics: true,
							},
							{
								id: '9d4e6b7f-2c8d-4e9a-8b1f-3e2c6f4d7b8a',
								number: '1.2.3.c)',
								name: 'Sexuelle Orientierung: Werbung darf niemanden (mittelbar oder unmittelbar) aufgrund seiner sexuellen Orientierung diskriminieren.',
								isFromCodeOfEthics: true,
							},
							{
								id: '1a2b3c4d-5e6f-4d7a-9b8c-2e3d4f5b6a7d',
								number: '1.2.3.d)',
								name: 'Behinderung, Beeinträchtigung: Werbung darf behinderte oder beeinträchtigte Menschen nicht (mittelbar oder unmittelbar) diskriminieren. Ein respektvoller Umgang ist stets zu wahren.',
								isFromCodeOfEthics: true,
							},
							{
								id: '3b4c5d6e-7f8a-4e9b-9c1d-2e3f4d5a6b7c',
								number: '1.2.3.e)',
								name: 'Religion: Werbung darf niemanden (mittelbar oder unmittelbar) aufgrund seiner Religion oder seines Glaubens diskriminieren.',
								isFromCodeOfEthics: true,
							},
							{
								id: '5a6b7c8d-9e0a-4f1b-8c2d-3e4f5a6b7c8d',
								number: '1.2.3.f)',
								name: 'Ethnizität/Nationalität: Werbung darf niemanden aufgrund seiner Nationalität bzw. seiner Herkunft diskriminieren. Menschen mit Migrationshintergrund sind stets als gleichwertig zu behandeln und dürfen nicht abgewertet werden.',
								isFromCodeOfEthics: true,
							},
						],
					},
					{
						id: '8d2b1c6f-4e8d-4e7a-80c1-6f2b7e4d9a3c',
						number: '1.2.4',
						name: 'Leid, Unglück oder Todesfälle dürfen nicht für Werbezwecke missbraucht werden; solche Darstellungen sind vielmehr nur dann zulässig, wenn sie das Ziel haben, dem Leid entgegen zu wirken, Unglück oder Unfälle zu verhindern, die Öffentlichkeit auf ein soziales Problem, einen Missstand, aufmerksam zu machen, oder wenn ein damit in unmittelbarem Zusammenhang stehendes Produkt beworben wird (z.B. Grabsteine, etc.).',
						isFromCodeOfEthics: true,
					},
				],
			},
			{
				id: 'f1d8b4c6-2e8d-4d7a-80c8-6b1e3f7d9a4b',
				number: '1.3',
				name: 'Gewalt',
				isFromCodeOfEthics: true,
				children: [
					{
						id: '7e2f8c1d-4b8d-4e7a-80f6-1d2c7e4b9a3c',
						number: '1.3.1',
						name: 'Werbung darf sich keiner gewalttätigen Darstellungen bedienen.',
						isFromCodeOfEthics: true,
						children: [
							{
								id: '9e3d7b8f-4c8d-4e7a-9b1f-2d6a8c4f1b3e',
								number: '1.3.1.a)',
								name: 'Werbung darf sich keiner gewalttätigen, Gewalt verharmlosenden, Gewalt ästhetisierenden oder Gewalt verherrlichenden Inhalte bedienen.',
								isFromCodeOfEthics: true,
							},
							{
								id: '4b2d9f3c-7e8a-4d1f-9b6e-3d2c7f8e1a4d',
								number: '1.3.1.b)',
								name: "Es dürfen keine Darstellungen und Aussagen erfolgen, die brutales, aggressives, asoziales oder gewalttätiges Verhalten abbilden oder zu solchen Verhaltensweisen ermutigen, diese fördern oder stillschweigend dulden, unabhängig von der Umsetzung (z. B. in der Form von Animation, Comics, Emojis und GIF's usw.).",
								isFromCodeOfEthics: true,
							},
							{
								id: '6a7d8c9e-4b3d-4e8a-8f1b-2d4c6f7e1a3b',
								number: '1.3.1.c)',
								name: 'Neben der physischen Gewalt darf Werbung auch nicht die Darstellung psychischer und sexualisierter Gewalt (z.B. Mobbing, Stalking) beinhalten. Auch heftige, aggressive Beschimpfungen sind unzulässig.',
								isFromCodeOfEthics: true,
							},
							{
								id: '5e4a7b3c-8f9d-4e1a-9b2f-6d3c4f8e1a5d',
								number: '1.3.1.d)',
								name: 'Darüber hinaus sind Darstellungen, die sexualisierte Gewalt beinhalten, abzulehnen.',
								isFromCodeOfEthics: true,
							},
							{
								id: '2b3a9d4c-5e7f-4e8a-8c1b-9d6e4f1a3b5d',
								number: '1.3.1.e)',
								name: 'Die Darstellung von Gewalt auch gegen Tiere sowie Vandalismus als inhaltlicher oder stilistischer Bestandteil werblicher Botschaften ist zu unterlassen.',
								isFromCodeOfEthics: true,
							},
							{
								id: '8c1e7d9a-6b4f-4e8d-8b1c-2d3a7f1e4c5d',
								number: '1.3.1.f)',
								name: 'Werbung darf weder Angst noch Furcht erzeugen. Angst- und Furchterregende Darstellungen und Aussagen dürfen nur dann erfolgen, wenn sie zu einem klugen, vernünftigen, rechtskonformen und sicheren Verhalten animieren. Dabei ist jedoch zu beachten, dass Furcht- und angsterregende Darstellungen in einem angemessenen Verhältnis zu der jeweiligen realen Gefährdung zu stehen haben.',
								isFromCodeOfEthics: true,
							},
							{
								id: '7e9b1c4a-5d8f-4e2d-9a3b-1f6d4e8c7a5d',
								number: '1.3.1.g)',
								name: 'Werbung darf keine Inhalte transportieren, die zwar vordergründig nicht gewalttätig erscheinen, im Gesamtzusammenhang aber als gewalttätig zu beurteilen sind. Auch heftige, aggressive Beschimpfungen sind unzulässig.',
								isFromCodeOfEthics: true,
							},
							{
								id: '3c5a7d1b-9e4f-4e8d-8f1c-2b6d7e4a1d5f',
								number: '1.3.1.h)',
								name: 'Massive Gewalt darf nicht humoristisch abgebildet werden.',
								isFromCodeOfEthics: true,
							},
						],
					},
					{
						id: '6f1b8e2c-8d7e-4d8a-80c7-9e2d3b6f1a4d',
						number: '1.3.2',
						name: 'Waffenwerbung',
						isFromCodeOfEthics: true,
						children: [
							{
								id: '9b2d6f4e-8c7a-4e1d-9a3b-2d6f7e1c8a4d',
								number: '1.3.2.a)',
								name: 'Bei der Bewerbung von Waffen muss darauf geachtet werden, dass der besonderen Gefahr, die bei deren unsachgemäßen Verwendung ausgeht, unbedingt Rechnung getragen werden wird. Daher muss bei der Bewerbung von Waffen grundsätzlich eine Kennzeichnung mittels Warnhinweis "Waffen gefährden bei unsachgemäßem Umgang Gesundheit & Leben" erfolgen.',
								isFromCodeOfEthics: true,
							},
							{
								id: '5c7a8e2b-9d1f-4e8a-8f1c-2d4b6f3a9e7d',
								number: '1.3.2.b)',
								name: 'Waffen dürfen nicht im tatsächlichen Gebrauch, gerichtet gegen Lebewesen, dargestellt werden.',
								isFromCodeOfEthics: true,
							},
							{
								id: '4e6d9b7a-3c8f-4e2a-8d1b-5f1c6e7a9b2d',
								number: '1.3.2.c)',
								name: 'Bei der Bewerbung von Waffen soll auf eine besonders verharmlosende, bzw. verherrlichende Darstellung verzichtet werden.',
								isFromCodeOfEthics: true,
							},
							{
								id: '2d4c6e8b-1f9a-4e7d-8c1b-9b3d7f6a2e5d',
								number: '1.3.2.d)',
								name: 'Auch die humoristische Darstellung von Waffen ist abzulehnen.',
								isFromCodeOfEthics: true,
							},
							{
								id: '8f1c2d4e-7b6d-4e9a-8b1f-3c5d6f7e1a9b',
								number: '1.3.2.e)',
								name: 'Waffen dürfen ohne direkten Zusammenhang mit dem beworbenen Produkt nicht dargestellt werden.',
								isFromCodeOfEthics: true,
							},
						],
					},
				],
			},
			{
				id: '8d2f1e6b-4c8d-4e7a-80b6-1f2d7e4c9a3b',
				number: '1.4',
				name: 'Gesundheit',
				isFromCodeOfEthics: true,
				children: [
					{
						id: '1f8d7c2e-8b6d-4e1a-80f6-3d2e7b4c9a2b',
						number: '1.4.1',
						name: 'Gesundheitswerbung darf nicht diskriminieren.',
						isFromCodeOfEthics: true,
					},
					{
						id: 'e2f1b6d8-7c4e-4d8a-80f7-1e3d2c6b8a4d',
						number: '1.4.2',
						name: 'Es dürfen keine Darstellungen und Aussagen erfolgen, die Personen aufgrund ihrer körperlichen oder geistig-seelischen Schwächen bzw. Krankheiten herabsetzen oder entwürdigen. Gleiches gilt für die körperliche Erscheinung bzw. das Aussehen von Personen.',
						isFromCodeOfEthics: true,
					},
					{
						id: '8b1d7c2f-4e6d-4d8a-80f1-9e2b3c6f1a4d',
						number: '1.4.3',
						name: 'Es dürfen keine Darstellungen oder Aussagen erfolgen, die ein gesundheitsschädigendes Verhalten oder gesundheitsschädigende Körperformen (z.B. Bulimie, Anorexie, Adipositas etc.) insbesondere in Bezug auf Körpergewicht, propagieren.',
						isFromCodeOfEthics: true,
					},
					{
						id: 'f6c8e1d4-2b7e-4d8a-80f1-3b4e7c6d9a2b',
						number: '1.4.4',
						name: 'Werbung soll den Konsum von Arzneimitteln nicht verharmlosen und nicht zu einem übermäßigen Konsum von Arznei- oder Nahrungsergänzungsmitteln ermutigen.',
						isFromCodeOfEthics: true,
					},
					{
						id: 'd4b8e6f2-7c1d-4d8a-80c7-1f2e3b7d9a4d',
						number: '1.4.5',
						name: 'Werbung für Arzneimittel und Nahrungsergänzungsmittel darf sich nicht an die Zielgruppe Kinder wenden.',
						isFromCodeOfEthics: true,
					},
					{
						id: 'c7e1d8f4-2b6e-4d8a-80f1-9e3c2b6d1a4d',
						number: '1.4.6',
						name: 'Werbung für Arzneimittel, Nahrungsergänzungsmittel, insbesondere Mittel zur Gewichtsreduktion, und Kosmetika, soll keinen direkten oder indirekten Kaufzwang auf die KonsumentInnen ausüben.',
						isFromCodeOfEthics: true,
					},
					{
						id: '8c2f1e6b-4d8d-4e7a-80b6-1e3d2f7c9a3b',
						number: '1.4.7',
						name: 'Es sollen keine Darstellungen und Aussagen erfolgen, die geeignet sind, die Hoffnungen von leidenden Menschen auszunützen.',
						isFromCodeOfEthics: true,
					},
					{
						id: 'f1d7b4e6-2c8e-4d8a-80f6-3b2e7c4d9a1b',
						number: '1.4.8',
						name: 'Gesundheitswerbung soll nicht irreführen.',
						isFromCodeOfEthics: true,
						children: [
							{
								id: '9e2b4c6d-7f1a-4e8a-9c1b-3d4a6e1f2b7c',
								number: '1.4.8.a)',
								name: "Angaben, die sich auf physiologische oder pharmakologische Wirkungen berufen und bei den KonsumentInnen den Eindruck erwecken, dass das beworbene Produkt 'Gesundheit' erhält, den Altersprozess aufhält oder rückgängig macht, bei gleichbleibender Lebensweise das Körpergewicht reduziert, eine diätische Wirkung vortäuscht oder ähnliches, sind zu unterlassen.",
								isFromCodeOfEthics: true,
							},
							{
								id: '6f3a2b7d-9e1c-4d8a-8f6b-1d7e4b9c3a2f',
								number: '1.4.8.b)',
								name: 'Werbung soll keine medizinischen oder wissenschaftlichen Fachausdrücke verwenden, die den/die durchschnittlichen KonsumentInnen irreführen können.',
								isFromCodeOfEthics: true,
							},
							{
								id: '4b9d6e3f-2c8a-4e1b-9f7c-3a2d6e8f1b4a',
								number: '1.4.8.c)',
								name: 'Es sollen keine Darstellungen und Aussagen erfolgen, die den Eindruck erwecken, natürliche Produkte, insbesondere Heilmittel, seien generell wirkungsvoller oder sicherer als andere.',
								isFromCodeOfEthics: true,
							},
							{
								id: '1d7c8e3b-5f2a-4e1d-9b6f-4a2b7e6c9a3d',
								number: '1.4.8.d)',
								name: 'Es sollen keine Darstellungen und Aussagen erfolgen, die den Eindruck erwecken, ein beworbenes Produkt könne im Zusammenhang mit der Behandlung suchtartiger Abhängigkeiten oder der Abgewöhnung schlechter Angewohnheiten ohne besondere Anforderungen an die Willenskraft der KonsumentInnen wirkungsvoll sein.',
								isFromCodeOfEthics: true,
							},
							{
								id: '3a7e4c1d-9b8f-4d6a-9f2b-1d4e6c7a8b3f',
								number: '1.4.8.e)',
								name: 'Im Zusammenhang mit Vitamin-, Mineral- oder anderen Präparaten bzw. Zusatzstoffen sollen keine Darstellungen und Aussagen erfolgen, die den Eindruck erwecken, solche Produkte wären ein Ersatz für ausgewogene und gesunde Ernährung bzw. würden einen wirksamen Schutz vor Krankheiten darstellen.',
								isFromCodeOfEthics: true,
							},
						],
					},
				],
			},
			{
				id: '7e2f8d1b-4c8d-4e7a-80f1-1b2c6e4d9a3c',
				number: '1.5',
				name: 'Sicherheit',
				isFromCodeOfEthics: true,
				children: [
					{
						id: '6f1d8c2b-8e4d-4d7a-80b6-1e3d7f4c9a2b',
						number: '1.5.1',
						name: 'Werbung soll die allgemeine Sicherheit nicht gefährden.',
						isFromCodeOfEthics: true,
					},
					{
						id: 'c940e174-7572-460a-b33b-9fe193170408',
						number: '1.5.2',
						name: 'Es sollen keine Darstellungen und Aussagen erfolgen, die sicherheitsgefährdende Verhaltensweisen bzw. Situationen darstellen oder zu solchem Verhalten ermutigen können. Insbesondere sind Darstellungen von kriegerischen Auseinandersetzungen, gewalttätigem oder asozialem Verhalten zu unterlassen.',
						isFromCodeOfEthics: true,
					},
					{
						id: 'f1e7d6c4-2b8e-4d8a-80f6-3b2d6f4e9a1b',
						number: '1.5.3',
						name: 'Werbung soll sich keiner unfallriskanter Bildmotive bedienen. Insbesondere ist die Darstellung falscher oder leichtsinniger Bedienung von Maschinen, Kraftfahrzeugen oder anderen Produkten zu unterlassen.',
						isFromCodeOfEthics: true,
					},
				],
			},
			{
				id: 'd4e1b7c8-2f6e-4d8a-80f1-1b2c7f4d9a3b',
				number: '1.6',
				name: 'Umwelt',
				isFromCodeOfEthics: true,
				children: [
					{
						id: 'c8e1d7f4-2b6e-4d8a-80f1-9e3d2b7c1a4d',
						number: '1.6.1',
						name: 'Konsument:innen und Zielgruppe',
						isFromCodeOfEthics: true,
						children: [
							{
								id: '9a2d4c7e-3b8f-4e1a-9c6f-1b4e2d7f3a8b',
								number: '1.6.1.a)',
								name: 'Werbung sollte so gestaltet werden, dass sie einen möglichen Mangel an Umweltwissen nicht ausnutzt und Sorgen und Ängste in Bezug auf die Umwelt nicht weiter verstärkt.',
								isFromCodeOfEthics: true,
							},
							{
								id: '7c3a2e1d-8b4f-4d6a-9f7e-1d2c3b8a9f6d',
								number: '1.6.1.b)',
								name: 'Es sollen Ausdrücke verwendet werden, die von der Zielgruppe gebräuchlich sind im Sinne des allgemeinen Verständnisses.',
								isFromCodeOfEthics: true,
							},
							{
								id: '4e7b1d9c-2f6a-4c8e-9d1f-3a7e2b6f9d4a',
								number: '1.6.1.c)',
								name: 'Konsument:innen sollen die Chance haben, sich tiefgehender über getätigte Aussagen in der Werbung zu informieren, im besten Fall in der Werbung selbst oder über einen QR-Code, einen Link, eine Quellenangabe oder eine andere Option.',
								isFromCodeOfEthics: true,
							},
						],
					},
					{
						id: 'f2e1b6d8-7c4e-4d8a-80f1-1e3d2c6f8a4d',
						number: '1.6.2',
						name: 'Wahre und belegbare Angaben',
						isFromCodeOfEthics: true,
						children: [
							{
								id: '8b1d6c2f-4e7d-4d8a-80f1-9e2b3c7f1a4d',
								number: '1.6.2.1',
								name: 'Spezifikation',
								isFromCodeOfEthics: true,
								children: [
									{
										id: '6c3e1d9b-2f4d-4a8c-9e1b-7d6e2a3f8b4c',
										number: '1.6.2.1.a)',
										name: 'Der Bereich / die Kategorie / der Prozess, auf den sich die werbliche Kommunikation bezieht, soll angegeben und belegbar sein. Die Kommunikation soll nicht den Eindruck erwecken, dass sich unspezifische Maßnahmen ungerechtfertigt auf die gesamte Leistung / den gesamten (Produktions-)Prozess eines Unternehmens bezieht.',
										isFromCodeOfEthics: true,
									},
									{
										id: '9b4d2e7a-8c1f-4d6b-9e3a-1c7e2b4f9d8a',
										number: '1.6.2.1.b)',
										name: 'Es sollte immer klar sein, auf welche Stufe, welchen Prozess, welches Produkt oder welches Element sich eine Aussage bezieht.',
										isFromCodeOfEthics: true,
									},
									{
										id: '7e1a4c3d-6f2b-4d8e-9c7b-2d4e3b8f1a6c',
										number: '1.6.2.1.c)',
										name: 'Der Zeitraum auf den sich eine Angabe wie z.B. Zielerreichung / Vision bezieht soll angegeben sein und realisierbar sein.',
										isFromCodeOfEthics: true,
									},
									{
										id: '2d9b6e1f-8c4a-4d7b-9f1e-3b2a7e4f9c6d',
										number: '1.6.2.1.d)',
										name: 'Eine Angabe zum Lebenszyklusnutzen sollte durch eine Lebenszyklusanalyse (LCA) untermauert werden.',
										isFromCodeOfEthics: true,
									},
								],
							},
							{
								id: 'e4d1f7b8-2c6e-4d8a-80f1-1e3c2b7d9a4d',
								number: '1.6.2.2',
								name: 'Belegbarkeit',
								isFromCodeOfEthics: true,
								children: [
									{
										id: '8f2a1d3b-6e4d-4c7b-9f3e-2b4a6d9e7c1f',
										number: '1.6.2.2.a)',
										name: 'Bei umweltbezogenen werblichen Aussagen sollen klare Quellen angegeben sein, so dass die Aussagen wissenschaftlich bzw. technisch belegbar sind.',
										isFromCodeOfEthics: true,
									},
									{
										id: '3d9e7c4a-2f6b-4e8d-9b1c-7e2a1b6f9d4c',
										number: '1.6.2.2.b)',
										name: 'Tiefergehende Informationen zur Werbemaßnahme sollten zusätzlich abrufbar sein.',
										isFromCodeOfEthics: true,
									},
								],
							},
							{
								id: 'f1c8e7d4-2b6e-4d8a-80f1-9e3d2c7b1a4d',
								number: '1.6.2.3',
								name: 'Attraktivität',
								isFromCodeOfEthics: true,
								children: [
									{
										id: '1e3b6c7d-4f2a-4d8e-9b1c-7f2d3e9a6c4b',
										number: '1.6.2.3.a)',
										name: 'Beworbene Maßnahmen sollen sich nachweislich positiv oder zumindest nicht nachteilig auf die Umwelt auswirken.',
										isFromCodeOfEthics: true,
									},
								],
							},
						],
					},
					{
						id: '7d1b8e6c-4f2e-4d8a-80f1-1e3d6c7b9a4d',
						number: '1.6.3',
						name: 'Fehlvorstellungen & Missinterpretationen',
						isFromCodeOfEthics: true,
						children: [
							{
								id: '8e2f1c6b-4d8d-4e7a-80f1-3b1d6c7b9a4d',
								number: '1.6.3.1',
								name: 'Sprache & Begrifflichkeiten allgemein',
								isFromCodeOfEthics: true,
								children: [
									{
										id: '4b2d8e1a-6f7c-4d8a-80f1-9e3d2c7b1a4d',
										number: '1.6.3.1.a)',
										name: 'Mit dem beworbenen Produkt oder der beworbenen Dienstleistung in Zusammenhang stehen.',
										isFromCodeOfEthics: true,
									},
									{
										id: '2e8c1d7b-4f6e-4d8a-80f1-1e3c2b6f9a4d',
										number: '1.6.3.1.b)',
										name: 'Belegt werden können (nach 1.6.2. Wahre und belegbare Angaben).',
										isFromCodeOfEthics: true,
									},
									{
										id: '3c7b1d9e-2f4e-4d8a-80f1-9e3d2b6f1a4d',
										number: '1.6.3.1.c)',
										name: 'Konkret untermauert werden, auf welchen Aspekt sich dieser Begriff wie und in welchem Ausmaß bezieht (nach 1.6.1. c) Konsument:innen und Zielgruppe).',
										isFromCodeOfEthics: true,
									},
								],
							},
							{
								id: 'f1e7c4d6-2b8e-4d8a-80f1-9e3b2c7f1a4d',
								number: '1.6.3.2',
								name: 'Leicht verständliche Sprache',
								isFromCodeOfEthics: true,
								children: [
									{
										id: '7e3b1d9f-4c8a-4d8e-80f1-2e3d6c7b9a4d',
										number: '1.6.3.2.a)',
										name: 'Es sollen keine Fachausdrücke oder Abkürzungen verwendet werden, die geeignet sind, Konsument:innen in die Irre führen zu können, ohne diese näher zu erläutern oder zu untermauern.',
										isFromCodeOfEthics: true,
									},
								],
							},
							{
								id: 'c7e1d8b4-2f6e-4d8a-80f1-1e3c2b6d9a4d',
								number: '1.6.3.3',
								name: 'Selbstverständliche Aussagen',
								isFromCodeOfEthics: true,
								children: [
									{
										id: '1e8c3b7d-4f2a-4d8e-80f1-9e3d2b7c1a4d',
										number: '1.6.3.3.a)',
										name: 'Es sollen keine selbstverständlichen und damit überflüssigen Aussagen gemacht werden, etwa dass ein Produkt eine bestimmte Eigenschaft hat oder eine bestimmte Zutat enthält, obwohl diese Bestandteile selbstverständlich sind bzw. sich bereits aus dem Produkt ergeben (Irreführende Werbung mit Selbstverständlichkeiten).',
										isFromCodeOfEthics: true,
									},
								],
							},
							{
								id: '8d1f7c2e-4b6d-4e8a-80f1-9e3d2c7b1a4d',
								number: '1.6.3.4',
								name: 'Zahlen und Prozentangaben',
								isFromCodeOfEthics: true,
								children: [
									{
										id: '2f9e7b4c-6d1a-4d8a-80f1-1e3c2b6f9a4d',
										number: '1.6.3.4.a)',
										name: 'Werden Zahlen und/oder Prozentangaben in der Werbung verwendet, sollen diese erklärt werden bzw. klar und schlüssig erläutert werden.',
										isFromCodeOfEthics: true,
									},
								],
							},
							{
								id: 'f2e1b7d6-2c8e-4d8a-80f1-1e3c2b6f9a4d',
								number: '1.6.3.5',
								name: 'Werbung und deren Bildsprache',
								isFromCodeOfEthics: true,
								children: [
									{
										id: '9e1b7c2d-4f6e-4d8a-80f1-2e3d6b7c9a4d',
										number: '1.6.3.5.a)',
										name: 'Die Werbemaßnahme inklusive ihrer Gestaltungselemente wie Bilder ist anhand deren Gesamterscheinung zu bewerten. Die Bildsprache darf Konsument:innen in Bezug auf Umweltaussagen und Darstellungen nicht in die Irre führen.',
										isFromCodeOfEthics: true,
									},
								],
							},
							{
								id: 'c8d1e7b4-4f6e-4d8a-80f1-9e3d2b7c1a4d',
								number: '1.6.3.6',
								name: 'Siegel, Signets, Symbole und Kennzeichnungen',
								isFromCodeOfEthics: true,
								children: [
									{
										id: '4f7e2d9c-1b6a-4d8e-80f1-9e3d2b6f1a4d',
										number: '1.6.3.6.a)',
										name: 'Die Verwendung von Umweltzeichen ist zu unterlassen, wenn damit möglicherweise falsche Tatsachen vorgetäuscht werden können.',
										isFromCodeOfEthics: true,
									},
									{
										id: '7c9d1e6b-4f8a-4d8e-80f1-1e3c2b7f9a4d',
										number: '1.6.3.6.b)',
										name: 'Die Gültigkeit, Herkunft und Bedeutung von Umweltzeichen sollen klar erkenntlich sein (Zertifizierung) bzw. soll im Rahmen der Werbemaßnahme auf eine Abrufmöglichkeit für diese Informationen hingewiesen werden.',
										isFromCodeOfEthics: true,
									},
									{
										id: '9b1e7c4d-6f2a-4d8e-80f1-3b2d6c7b1a4d',
										number: '1.6.3.6.c)',
										name: 'Die Verwendung eines Umweltkennzeichens ist zu unterlassen, wenn die Gefahr einer Verwechslung oder Infragestellung seiner Bedeutung besteht.',
										isFromCodeOfEthics: true,
									},
								],
							},
						],
					},
					{
						id: 'f1e7b4d6-2b8e-4d8a-80f1-1e3c2b7d9a4d',
						number: '1.6.4',
						name: 'Vergleichende Aussagen in der Werbung',
						isFromCodeOfEthics: true,
						children: [
							{
								id: 'c8e1d7f4-4b6e-4d8a-80f1-9e3d2c7f1a4d',
								number: '1.6.4.1',
								name: 'Vergleiche',
								isFromCodeOfEthics: true,
								children: [
									{
										id: '7b1e6d2f-4c8e-4d8a-80f1-2e3d6b7c9a4d',
										number: '1.6.4.1.a)',
										name: 'Produkte bzw. Dienstleistungen dürfen in der Werbemaßnahme nur dann miteinander verglichen werden, wenn diese für den gleichen Zweck oder für das gleiche Bedürfnis bestimmt sind und der Vergleich ausreichend begründet wird.',
										isFromCodeOfEthics: true,
									},
									{
										id: '9e3b1c7d-2f6e-4d8a-80f1-1e3c2b6d9a4d',
										number: '1.6.4.1.b)',
										name: 'Der Vergleich und die damit getätigte Aussage muss begründet und belegbar sein und darf keine irreführenden und falschen Eindrücke erwecken.',
										isFromCodeOfEthics: true,
									},
								],
							},
							{
								id: 'f2e1b6d8-2f8e-4d8a-80f1-1e3c2b7d9a4d',
								number: '1.6.4.2',
								name: 'Aussparungen, Kompensation',
								isFromCodeOfEthics: true,
								children: [
									{
										id: '3b1d7e2c-4f8e-4d8a-80f1-9e3c2b6f1a4d',
										number: '1.6.4.2.a)',
										name: 'Wird damit geworben, dass das Weglassen oder Aussparen eines Inhaltsstoffs, einer Komponente oder eines Produktes positive Auswirkungen auf die Umwelt habe, so muss dies belegbar sein.',
										isFromCodeOfEthics: true,
									},
									{
										id: '4e7b1d9f-2c6a-4d8a-80f1-1e3d6c7b9a4d',
										number: '1.6.4.2.b)',
										name: 'Es sollte klar sein, welche Komponente genau reduziert wurde und wie dadurch die beworbene positive Auswirkung auf die Umwelt unter Betrachtung aller relevanten Aspekte des Produktes, des Prozesses bzw. der Dienstleistung erreicht wird.',
										isFromCodeOfEthics: true,
									},
									{
										id: '6e2d9b1c-4f7e-4d8a-80f1-3b1e6c7d9a4d',
										number: '1.6.4.2.c)',
										name: 'Zudem muss auch nachgewiesen werden, dass dieser Inhaltsstoff, diese Komponente oder dieses Produkt früher verwendet wurde und nun nicht mehr verwendet bzw. eingespart wird (wenn damit ausdrücklich geworben wird, dass dadurch eine Verbesserung der Produktlinie erreicht wurde).',
										isFromCodeOfEthics: true,
									},
								],
							},
						],
					},
				],
			},
			{
				id: '7d1f8e6b-4c2e-4d8a-80f1-1e3c6f7b9a4d',
				number: '1.7',
				name: 'Rechtswidriges Werbeumfeld',
				isFromCodeOfEthics: true,
				children: [
					{
						id: '8f2e1d6c-4b8d-4e7a-80f1-3b1c6f7b9a4d',
						number: '1.7.1',
						name: 'Verletzung des Datenschutzgesetzes',
						isFromCodeOfEthics: true,
					},
					{
						id: 'f1e7d4b6-2c8e-4d8a-80f1-1e3c2b7d9a4d',
						number: '1.7.2',
						name: 'Verletzung von Rechten gemäß dem Urhebergesetz',
						isFromCodeOfEthics: true,
					},
					{
						id: 'c8d1e7b4-4f2e-4d8a-80f1-9e3d2c6b1a4d',
						number: '1.7.3',
						name: 'Verstoß gegen das (NS-) Verbotsgesetz 1947',
						isFromCodeOfEthics: true,
					},
					{
						id: '8e2f1d6b-4b7d-4e8a-80f1-1e3c2b7d9a4d',
						number: '1.7.4',
						name: 'Verstoß gegen das Pornographiegesetz und/oder gegen die Bestimmungen des Strafgesetzbuches über strafbare Handlungen gegen die sexuelle Integrität und Selbstbestimmung',
						isFromCodeOfEthics: true,
					},
					{
						id: 'f1d7b4e6-2b8e-4d8a-80f1-3b2e6c7d1a4d',
						number: '1.7.5',
						name: 'Verletzung der Bestimmungen des Strafgesetzbuches über strafbare Handlungen gegen den öffentlichen Frieden (insbesondere Verbreitung von terroristischen und/oder verhetzenden Inhalten)',
						isFromCodeOfEthics: true,
					},
					{
						id: 'c8e1d7f4-2b6e-4d8a-80f1-1e3d2c7b9a4d',
						number: '1.7.6',
						name: 'Verstoß gegen das Kriegsmaterialiengesetz und/oder das Waffengesetz',
						isFromCodeOfEthics: true,
					},
					{
						id: '8d1f7e2c-4b8d-4e7a-80f1-3b1c6e7d9a4d',
						number: '1.7.7',
						name: 'Verstoß gegen das Suchtmittelgesetz',
						isFromCodeOfEthics: true,
					},
				],
			},
			{
				id: 'f2e1b7d6-2c8e-4d8a-80f1-1e3d2c7f9a4d',
				number: '1.8',
				name: 'Influencer Marketing',
				isFromCodeOfEthics: true,
				children: [
					{
						id: 'c8e1d7f4-4b6e-4d8a-80f1-9e3d2c7b1a4d',
						number: '1.8.1',
						name: 'Insbesondere bei Werbung, die sich direkt an Kinder und Jugendliche richtet (2.2.) darf keine offensichtliche oder versteckte Aufforderung zum Kauf des beworbenen Produktes erfolgen.',
						isFromCodeOfEthics: true,
					},
					{
						id: '8f2d1c6b-4e8d-4d7a-80f1-1e3b2c7f9a4d',
						number: '1.8.2',
						name: "Gesunde Körperformen: Es muss bei der Werbemaßnahme darauf geachtet werden, dass keine Abbildungen (Selfies, Bilder usw.) von Influencern eingesetzt werden, die ein gesundheitsschädigendes Verhalten oder gesundheitsschädigende Körperformen (z.B. Bulimie, Anorexie, Adipositas etc.) insbesondere in Bezug auf Körpergewicht propagieren - siehe dazu im Speziellen '1.4. Gesundheit (1.4.3.)')",
						isFromCodeOfEthics: true,
					},
					{
						id: 'f1e7d6b4-2b8e-4d8a-80f1-3b2c6e7d1a4d',
						number: '1.8.3',
						name: "Diskriminierung und Ausgrenzung im Zusammenhang mit psychischer und sozialer Gewalt (siehe '1.3. Gewalt (1.3.1.b)'). Es ist darauf zu achten, dass Influencer auch keine psychische und verbale Gewalt anwenden. Dazu gehört insbesondere das Verächtlichmachen Einzelner oder von Gruppen, Beschimpfungen und Drohungen sowie die Erzeugung von Angst, etwa in Form von Praktiken wie dem 'Pranking'",
						isFromCodeOfEthics: true,
					},
				],
			},
		],
	},
	{
		id: '799d1c4a-5c54-4b8e-9340-8f7b4e6d7c8e',
		number: '2',
		name: 'Spezielle Verhaltensregeln',
		isFromCodeOfEthics: true,
		children: [
			{
				id: 'd5a1c3b4-8e54-4b9a-9340-8e6d7f7b4c8e',
				number: '2.1',
				name: 'Geschlechterdiskriminierende Werbung (sexistische Werbung)',
				isFromCodeOfEthics: true,
				children: [
					{
						id: 'f4a2b3c1-9e54-4b8a-9340-8e7b5d6c8e9d',
						number: '2.1.1',
						name: 'Werbung darf nicht aufgrund des Geschlechts diskriminieren. Wesentlich dabei ist die Betrachtung der Werbemaßnahme im Gesamtkontext. Zu berücksichtigen sind insbesondere die verwendete Bild-Text-Sprache, Darstellungsweise (Ästhetik, künstlerische Gestaltungselemente), Zielgruppenausrichtung und damit einhergehend, in welchem Umfeld die Werbemaßnahme platziert ist.',
						isFromCodeOfEthics: true,
					},
					{
						id: 'c2b1a3f4-5e64-4b9a-9340-8e5d7b4c9e8d',
						number: '2.1.2',
						name: 'Geschlechterdiskriminierende Werbung (sexistische Werbung) liegt insbesondere vor, wenn Personen auf abwertende, verächtlich machende oder verspottende Weise dargestellt werden',
						isFromCodeOfEthics: true,
					},
					{
						id: 'd3c2b4a1-8e64-4b9a-9340-8e6d5b4c8e7d',
						number: '2.1.3',
						name: 'Geschlechterdiskriminierende Werbung (sexistische Werbung) liegt insbesondere vor, wenn die Gleichwertigkeit der Geschlechter in Frage gestellt wird',
						isFromCodeOfEthics: true,
					},
					{
						id: 'f2b1c3d4-6e74-4b8a-9340-8e5d6c7b4e9d',
						number: '2.1.4',
						name: 'Geschlechterdiskriminierende Werbung (sexistische Werbung) liegt insbesondere vor, wenn Unterwerfung oder Ausbeutung dargestellt oder zu verstehen gegeben wird, dass Gewalt oder Dominanzgebaren tolerierbar seien',
						isFromCodeOfEthics: true,
					},
					{
						id: 'e3c2b4d1-7e84-4b8a-9340-8e6d7b5c4e8d',
						number: '2.1.5',
						name: 'Geschlechterdiskriminierende Werbung (sexistische Werbung) liegt insbesondere vor, wenn die Person auf ihre Geschlechtsmerkmale reduziert und dies in den Mittelpunkt der Werbegestaltung gerückt wird',
						isFromCodeOfEthics: true,
					},
					{
						id: 'd4b1c2f3-8e94-4b8a-9340-8e7d6c5b4e9d',
						number: '2.1.6',
						name: 'Geschlechterdiskriminierende Werbung (sexistische Werbung) liegt insbesondere vor, wenn sexualisierte Darstellungsweisen ohne direkten inhaltlichen Zusammenhang zum beworbenen Produkt verwendet werden. Wesentlich ist dabei die Betrachtung im Gesamtkontext',
						isFromCodeOfEthics: true,
					},
					{
						id: 'e4c1b2d3-6e64-4b9a-9340-8e5d7c4b6e9d',
						number: '2.1.7',
						name: 'Geschlechterdiskriminierende Werbung (sexistische Werbung) liegt insbesondere vor, wenn die Würde des Menschen im Bereich der Sexualität verletzt wird',
						isFromCodeOfEthics: true,
					},
					{
						id: 'c3b1a2d4-7e74-4b9a-9340-8e6d5b4c8e9d',
						number: '2.1.8',
						name: 'Geschlechterdiskriminierende Werbung (sexistische Werbung) liegt insbesondere vor, wenn Personen abgewertet werden, die nicht den vorherrschenden Vorstellungen über Zugehörigkeit zu einem Geschlecht entsprechen (z. B.: intergeschlechtlich, transgender Menschen)',
						isFromCodeOfEthics: true,
					},
					{
						id: 'd5c1b2e3-8e84-4b8a-9340-8e7d6b5c4e9d',
						number: '2.1.9',
						name: 'Werbung für sexuelle Dienstleistungen darf, soweit sie rechtlich zulässig ist, die Würde von Menschen, insbesondere von SexdienstleisterInnen, Konsumentinnen oder Passantinnen, nicht verletzen. Körper und insbesondere Sexualität dürfen in der Bild-Text-Sprache nicht unangemessen dargestellt werden. Dabei ist auch besonders auf die Platzierung, den Zeitpunkt und das jeweilige Umfeld des Werbesujets zu achten',
						isFromCodeOfEthics: true,
					},
					{
						id: 'e5b1c2d3-6e74-4b9a-9340-8e5d7c4b6e9d',
						number: '2.1.10',
						name: 'Werbung darf Aufstachelung zum Hass, insbesondere aufgrund der unter „Ethik und Moral“, 1.2 genannten Kategorien, weder aufweisen, noch billigen, fördern oder verherrlichen. Werbung darf insbesondere kein Material enthalten, das, wenn es im jeweiligen Zusammenhang beurteilt wird, Gewalt gegen Personen billigt, fördert oder verherrlicht oder Kinder und Jugendliche in sexualisierter Weise darstellt',
						isFromCodeOfEthics: true,
					},
				],
			},
			{
				id: 'd1b1a2f3-7e74-4b8a-9340-8e5d6b4c7e9d',
				number: '2.2',
				name: 'Kinder und Jugendliche',
				isFromCodeOfEthics: true,
				children: [
					{
						id: 'c2a1b3d4-8e94-4b8a-9340-8e6d7c5b4e9d',
						number: '2.2.1',
						name: 'Kinder (darunter werden Personen vor dem vollendeten 12. Lebensjahr verstanden)',
						isFromCodeOfEthics: true,
						children: [
							{
								id: 'd3b2a1f4-5e64-4b9a-9340-8e5d7b4c9e8d',
								number: '2.2.1.1',
								name: 'Werbung allgemein',
								isFromCodeOfEthics: true,
								children: [
									{
										id: '9730f3b3-3cda-4ed7-9a64-5e0d7b5680c2',
										number: '2.2.1.1.a)',
										name: 'Werbung darf kein gewaltsames, aggressives oder asoziales Verhalten als nachahmens- oder billigenswert darstellen oder erscheinen lassen.',
										isFromCodeOfEthics: true,
									},
									{
										id: '259cf700-f439-4ba7-b078-57c023a2ff40',
										number: '2.2.1.1.b)',
										name: 'Werbung darf Kindern keine Inhalte kommunizieren bzw. nicht mit Bildern arbeiten, die Kindern physischen, psychischen oder moralischen Schaden zufügen können.',
										isFromCodeOfEthics: true,
									},
									{
										id: '6528e389-016d-4c5a-aeee-52f2976a482d',
										number: '2.2.1.1.c)',
										name: 'Werbung darf das seelische Wohl von Kindern insbesondere durch Angst oder Schrecken erzeugende Darstellungen, nicht gefährden.',
										isFromCodeOfEthics: true,
									},
									{
										id: 'ed64d2e4-7fd4-4fc4-a0c9-7334c5d08fb5',
										number: '2.2.1.1.d)',
										name: 'Werbung darf keine gefährlichen, ungesunden oder leichtsinnigen Handlungen darstellen oder Kinder zu solchen Verhaltensweisen animieren. ',
										isFromCodeOfEthics: true,
									},
									{
										id: 'fd4095bb-b27f-4914-a3fc-a481c425d046',
										number: '2.2.1.1.e)',
										name: 'In der Werbung dürfen keine Erziehungsmaßnahmen angedeutet oder dargestellt werden, die geeignet sind, das körperliche oder seelische Wohl und die Würde des Kindes zu beeinträchtigen oder zu verletzen. Dies gilt vor allem, wenn diese Maßnahmen durch Personen dargestellt werden, die Eltern oder sonstige Erziehungsberechtigte oder PädagogInnen verkörpern.',
										isFromCodeOfEthics: true,
									},
									{
										id: '8248eb7f-2d8f-4111-acc5-a80e92cb17f7',
										number: '2.2.1.1.f)',
										name: 'Werbung  darf Kinder nicht in diskriminierender Weise darstellen, wenn sie das beworbene Produkt nicht kaufen bzw. besitzen. Insbesondere sind Darstellungen und Aussagen zu unterlassen, die solche Kinder ausgrenzen, indem sie diese zum Beispiel als unpopulär, gesellschaftlich minderwertig oder unfolgsam erscheinen lassen. ',
										isFromCodeOfEthics: true,
									},
									{
										id: '26e7e529-2486-45a5-97fc-fce79645e291',
										number: '2.2.1.1.g)',
										name: 'Produktbezogene Angaben hinsichtlich Jugendschutz und weitere Warnhinweise müssen auch auf Werbemaßnahmen klar erkennbar sein.',
										isFromCodeOfEthics: true,
									},
									{
										id: '2e0fb670-824a-4375-a0f3-89db39ab63c7',
										number: '2.2.1.1.h)',
										name: 'Werbung  darf Kinder nicht ohne berechtigten Grund in gefährlichen Situationen zeigen.',
										isFromCodeOfEthics: true,
									},
								],
							},
							{
								id: 'e2b1a3d4-6e74-4b8a-9340-8e5d6c4b7e9d',
								number: '2.2.1.2',
								name: 'Werbung, die sich direkt an Kinder richtet',
								isFromCodeOfEthics: true,
								children: [
									{
										id: 'd93f72e3-8c12-4c1e-a4cb-3a0e80d5f491',
										number: '2.2.1.2.a)',
										name: 'Werbung oder Verkaufsförderungsmaßnahmen müssen den Mangel an Reife und Erfahrung von Kindern berücksichtigen. Darstellungen und Aussagen müssen dem jeweiligen Alter der Zielgruppe angepasst sein und dürfen die kindliche Vorstellungskraft nicht überfordern oder missbrauchen.',
										isFromCodeOfEthics: true,
									},
									{
										id: '507c99d7-ff9a-4981-bc2e-68c8c561a832',
										number: '2.2.1.2.b)',
										name: 'Werbung mit Kindern darf nicht geschlechterdiskriminierend sein.',
										isFromCodeOfEthics: true,
									},
									{
										id: 'f2b7aa25-3e4b-4cf1-af35-1b9e69052f34',
										number: '2.2.1.2.c)',
										name: 'Werbung für nicht kindergerechte Produkte wie z.B. Alkohol, Tabak, Arzneimittel, Waffen, Nahrungsergänzungsmittel und Schlankheitspräparate oder bestimmte Dienstleistungen (wie z.B. Glücksspiele, Wetten) darf sich nicht an die Zielgruppe Kinder wenden.',
										isFromCodeOfEthics: true,
									},
									{
										id: 'a8b3f2d1-9754-4f28-9c28-ff7b51f32c45',
										number: '2.2.1.2.d)',
										name: 'Kinder haben begrenztes Wissen, weniger Erfahrung und einen geringeren Wortschatz als Erwachsene. Werbung soll diesem Umstand durch einfache, klare und vollständige Informationen Rechnung tragen und darf Kinder nicht irreführen.',
										isFromCodeOfEthics: true,
									},
									{
										id: '652bf3f5-144d-42d0-b11b-b53ec5e75e9b',
										number: '2.2.1.2.e)',
										name: 'Werbung darf nicht mit Darstellungen arbeiten, in denen Kinder ihre Eltern oder Dritte unmittelbar dazu auffordern/überreden, ein bestimmtes Produkt zu kaufen.',
										isFromCodeOfEthics: true,
									},
									{
										id: 'f9c7a74e-304f-485e-8a03-c7e2e21c4c33',
										number: '2.2.1.2.f)',
										name: 'An Kinder gerichtete Werbung muss besonders gekennzeichnet sein, sodass jede Verwechslung mit einem Teil des Programms bzw. einem redaktionellen Beitrag ausgeschlossen ist.',
										isFromCodeOfEthics: true,
									},
								],
							},
							{
								id: 'f3b1c2a4-7e84-4b8a-9340-8e6d7b5c4e9d',
								number: '2.2.1.3',
								name: 'Werbung mit Kindern als DarstellerInnen',
								isFromCodeOfEthics: true,
								children: [
									{
										id: '7fbb39e1-7254-4d21-85d8-9e6f3e26e5e8',
										number: '2.2.1.3.a)',
										name: 'Werbung mit Kindern darf nicht geschlechterdiskriminierend sein.',
										isFromCodeOfEthics: true,
									},
									{
										id: 'e2f7d12d-5f28-41e6-a35c-b04e84b00a1f',
										number: '2.2.1.3.b)',
										name: 'Kinder dürfen nicht in erotisierender oder sexualisierter Weise dargestellt werden bzw. darf die Darstellung von Kindern nicht darauf abzielen, sexuelles Begehren zu wecken.',
										isFromCodeOfEthics: true,
									},
									{
										id: '9a9e1d4f-c6d7-4ed4-90f3-7f1b8e986a2b',
										number: '2.2.1.3.c)',
										name: 'Kinder dürfen niemals in entwürdigender Weise dargestellt oder lächerlich gemacht werden.',
										isFromCodeOfEthics: true,
									},
									{
										id: '62c7b8df-40d4-4e0f-b116-5a5dd0178c55',
										number: '2.2.1.3.d)',
										name: 'Kinder dürfen weder als Opfer von wie immer gearteter Gewalt, noch gewaltausübend dargestellt werden.',
										isFromCodeOfEthics: true,
									},
									{
										id: 'b347e7e8-0978-4d72-aa6c-4f3e3795fda1',
										number: '2.2.1.3.e)',
										name: 'In Werbung für nicht kindergerechte Produkte oder Dienstleistungen, die geeignet sind, das Wohl oder die Gesundheit von Kindern zu beeinträchtigen oder zu gefährden, dürfen Kinder nicht als DarstellerInnen eingesetzt werden; insbesondere zählt dazu Werbung für Waffen, Schönheitsoperationen, Glücksspiele, Wetten, Tabak, Alkohol und Videospiele mit nicht kindgerechten und/oder gewaltverherrlichenden Inhalten.',
										isFromCodeOfEthics: true,
									},
									{
										id: 'a94f6035-1a4b-4f57-ba1b-8485c17dbbf0',
										number: '2.2.1.3.f)',
										name: 'Werbung soll keine Äußerungen oder Empfehlungen von Kindern über besondere Vorteile und Eigenarten des Produktes enthalten, welche nicht den natürlichen Lebensäußerungen eines Kindes entsprechen.',
										isFromCodeOfEthics: true,
									},
								],
							},
							{
								id: 'd4a1b2c3-8e94-4b8a-9340-8e7d6c5b4e9d',
								number: '2.2.1.4',
								name: 'Unangebrachte audiovisuelle kommerzielle Kommunikation rund um Kindersendungen',
								isFromCodeOfEthics: true,
								children: [
									{
										id: 'e3b1a2d4-6e74-4b9a-9340-8e5d7c4b6e9d',
										number: '2.2.1.4.1',
										name: 'Allgemeine Grundsätze',
										isFromCodeOfEthics: true,
										children: [
											{
												id: 'bcf304d5-5c6a-4675-9b89-0993c7f2b375',
												number: '2.2.1.4.1.a)',
												name: 'Audiovisuelle kommerzielle Kommunikation für diese Lebensmittel soll so gestaltet sein, dass das Vertrauen der Kinder in die Qualität der beworbenen Produkte nicht missbraucht wird.',
												isFromCodeOfEthics: true,
											},
											{
												id: '6b42b9f0-0bf8-4818-a2d2-1e8665a61c19',
												number: '2.2.1.4.1.b)',
												name: 'Audiovisuelle kommerzielle Kommunikation für diese Lebensmittel soll einem gesunden, aktiven Lebensstil nicht entgegenwirken. Sie darf insbesondere nicht suggerieren, dass ein inaktiver Lebensstil körperlicher Bewegung vorzuziehen ist.',
												isFromCodeOfEthics: true,
											},
											{
												id: '28d67b2e-0c6e-43b3-b1a0-4f3ce506d377',
												number: '2.2.1.4.1.c)',
												name: 'Audiovisuelle kommerzielle Kommunikation für diese Lebensmittel soll einer ausgewogenen, gesunden Ernährung nicht entgegenwirken oder diese herabsetzen. Sie darf insbesondere nicht den Konsum von frischem Obst oder Gemüse abwerten bzw. davon abraten/abschrecken.',
												isFromCodeOfEthics: true,
											},
											{
												id: '2b3e9df7-0247-45d7-8308-c0cc84f732ad',
												number: '2.2.1.4.1.d)',
												name: 'Audiovisuelle kommerzielle Kommunikation für diese Lebensmittel soll nicht zu einem übermäßigen oder einseitigen Konsum der beworbenen Produkte auffordern. Die positive Darstellung zwang- oder krankhafter Essgewohnheiten ist unzulässig.',
												isFromCodeOfEthics: true,
											},
											{
												id: '38226b79-9b3c-4b73-ba7c-d27f5f0f7bea',
												number: '2.2.1.4.1.e)',
												name: 'Audiovisuelle kommerzielle Kommunikation für diese Lebensmittel soll den Verzicht auf den Konsum der beworbenen Produkte nicht abwertend darstellen.',
												isFromCodeOfEthics: true,
											},
											{
												id: 'f7c1e059-78a8-4c90-8a4c-bfb1f7f08938',
												number: '2.2.1.4.1.f)',
												name: 'Positive Eigenschaften der beworbenen Lebensmittel und Getränke, deren übermäßige Aufnahme im Rahmen der Gesamternährung nicht empfohlen wird, dürfen nicht hervorgehoben werden.',
												isFromCodeOfEthics: true,
											},
										],
									},
									{
										id: 'f4b1c2a3-7e84-4b8a-9340-8e6d7b5c4e9d',
										number: '2.2.1.4.2',
										name: 'Spezielle Bestimmungen',
										isFromCodeOfEthics: true,
										children: [
											{
												id: '83f0a6c6-35f6-4d2a-85d4-7d93f9e5e6a1',
												number: '2.2.1.4.2.a)',
												name: 'Audiovisuelle kommerzielle Kommunikation für diese Lebensmittel darf keinerlei Verbindung zwischen einer Verbesserung der schulischen Leistung und dem Genuss dieser Lebensmittel herstellen.',
												isFromCodeOfEthics: true,
											},
											{
												id: '48b5bda8-1a78-4cf3-849e-6553ee56b036',
												number: '2.2.1.4.2.b)',
												name: 'Audiovisuelle kommerzielle Kommunikation für diese Lebensmittel darf nicht den Eindruck erwecken, der Besitz oder der Konsum dieser Lebensmittel fördere sozialen Erfolg oder sichere einen höheren Status und größere Popularität in der Altersgruppe der Kinder.',
												isFromCodeOfEthics: true,
											},
											{
												id: 'fb1c9a4a-5f47-46a3-bc0b-7e53a665b12f',
												number: '2.2.1.4.2.c)',
												name: 'Audiovisuelle kommerzielle Kommunikation für diese Lebensmittel darf keine therapeutische, heilende oder Krankheiten vorbeugende Wirkung dieser Lebensmittel suggerieren.',
												isFromCodeOfEthics: true,
											},
											{
												id: '0d45b2a6-5ccf-4c6e-90be-6d896168a7bf',
												number: '2.2.1.4.2.d)',
												name: 'Audiovisuelle kommerzielle Kommunikation für diese Lebensmittel darf Unmäßigkeit im Genuss dieser Lebensmittel nicht fördern oder Mäßigung oder Enthaltsamkeit nicht negativ darstellen.',
												isFromCodeOfEthics: true,
											},
											{
												id: '67f79b4a-6ebc-4a83-89b4-6e17194f08e6',
												number: '2.2.1.4.2.e)',
												name: 'Audiovisuelle kommerzielle Kommunikation für diese Lebensmittel darf keine negativen Aussagen über Personen enthalten, die – aus welchem Grund auch immer – den Konsum dieser Lebensmittel reduzieren wollen.',
												isFromCodeOfEthics: true,
											},
											{
												id: '6e2f1a91-d6f5-4b5e-98a0-3946f3330e6d',
												number: '2.2.1.4.2.f)',
												name: 'Audiovisuelle kommerzielle Kommunikation für diese Lebensmittel darf nicht suggerieren, dass diese Lebensmittel eine Mahlzeit ersetzen könnten. Sie darf insbesondere nicht andeuten, dass diese Lebensmittel einen vollständigen Ersatz für Gemüse und/oder Obst darstellen können.',
												isFromCodeOfEthics: true,
											},
											{
												id: 'f6d33332-7801-4e29-97e7-6e66ef3e5f27',
												number: '2.2.1.4.2.g)',
												name: 'Audiovisuelle kommerzielle Kommunikation für kalorienreduzierte Abwandlungen dieser Lebensmittel („Light-Versionen“) darf nicht zu exzessivem Konsum des kalorienreduzierten Lebensmittels auffordern.',
												isFromCodeOfEthics: true,
											},
											{
												id: '5a8e7c1e-7d02-4174-95d7-3bcb7fa9ea95',
												number: '2.2.1.4.2.h)',
												name: 'Audiovisuelle kommerzielle Kommunikation für diese Lebensmittel und die darin angesprochenen Informationen über Geschmack, Portionsgröße und den möglichen Beitrag dieser Lebensmittel zu einer ausgewogenen Ernährung müssen wahrheitsgemäß, vollständig und nachvollziehbar sein.',
												isFromCodeOfEthics: true,
											},
											{
												id: 'a46d7e59-ee5d-4d4e-ae61-75d23a227d71',
												number: '2.2.1.4.2.i)',
												name: 'Audiovisuelle kommerzielle Kommunikation für diese Lebensmittel und die darin enthaltenen Angaben über die in diesen Lebensmitteln enthaltene Menge an Kohlenhydraten, Fett oder Eiweiß dürfen nicht auf irreführende Weise positive Effekte für eine ausgewogene Gesamternährung suggerieren (z.B. sollen stark kohlenhydrathaltige Nahrungsmittel nicht durch einen Hinweis auf ihren fettarmen oder -losen Inhalt beworben werden und umgekehrt).',
												isFromCodeOfEthics: true,
											},
											{
												id: 'fd4e071d-7b99-4f4f-b9d7-7f0478baf14d',
												number: '2.2.1.4.2.j)',
												name: 'Wenn diese Lebensmittel in direktem Zusammenhang mit Kindersendungen stehen (z.B. Lizenzprodukte), darf die audiovisuelle kommerzielle Kommunikation dafür nicht unmittelbar vor, während oder nach diesen Sendungen ausgestrahlt werden.',
												isFromCodeOfEthics: true,
											},
											{
												id: 'c5c4f316-9203-4e7f-8f36-2c517f44a96d',
												number: '2.2.1.4.2.k)',
												name: 'Audiovisuelle kommerzielle Kommunikation für diese Lebensmittel darf Kindern weder körperlichen noch seelischen Schaden zufügen.',
												isFromCodeOfEthics: true,
											},
											{
												id: 'c2c114f4-23bf-433e-9c30-727dbb6c88a8',
												number: '2.2.1.4.2.l)',
												name: 'Audiovisuelle kommerzielle Kommunikation für diese Lebensmittel darf keine direkten Kaufappelle für diese Lebensmittel an Kinder richten, die deren Unerfahrenheit und Leichtgläubigkeit ausnutzen.',
												isFromCodeOfEthics: true,
											},
											{
												id: 'ddc2d4f7-4c4f-45b8-bc4d-51b4c63ea2f0',
												number: '2.2.1.4.2.m)',
												name: 'Audiovisuelle kommerzielle Kommunikation für diese Lebensmittel darf Kinder nicht unmittelbar dazu auffordern, ihre Eltern oder Dritte zum Kauf dieser Lebensmittel zu bewegen.',
												isFromCodeOfEthics: true,
											},
											{
												id: '877c27f7-7f0e-4a67-b742-88214abba7f1',
												number: '2.2.1.4.2.n)',
												name: 'Audiovisuelle kommerzielle Kommunikation für diese Lebensmittel darf in unangebrachter Weise durch explizite Kaufaufforderung das besondere Vertrauen ausnutzen, das Kinder zu Eltern, Lehrern und anderen natürlichen Vertrauenspersonen (u.a. Kinderidole 7) haben und dadurch dem Erlernen einer ausgewogenen Ernährung und eines gesunden Lebensstils entgegenwirken. Sie darf weiters nicht suggerieren, dass der Konsum dieser Lebensmittel Kinder unmittelbar in die Lage versetzt, die Popularität oder den sozialen Status dieser Personen zu erlangen.',
												isFromCodeOfEthics: true,
											},
										],
									},
								],
							},
						],
					},
					{
						id: 'c3a1b2d4-7e74-4b8a-9340-8e5d6b4c8e9d',
						number: '2.2.2',
						name: 'Jugendliche (darunter werden Personen zwischen dem vollendeten 12. und vor dem vollendeten 18. Lebensjahr verstanden)',
						isFromCodeOfEthics: true,
						children: [
							{
								id: 'd4b1a2f3-8e84-4b8a-9340-8e6d7c5b4e9d',
								number: '2.2.2.1',
								name: 'Werbung allgemein',
								isFromCodeOfEthics: true,
								children: [
									{
										id: 'bb2e9b66-c1ab-4e88-88a5-7c6e1b6cfb0d',
										number: '2.2.2.1.a)',
										name: 'Werbung darf keine leichtsinnigen und/oder gefährlichen Handlungen darstellen, die Jugendliche zur Nachahmung animieren.',
										isFromCodeOfEthics: true,
									},
									{
										id: 'c5d7a293-8d31-4a0a-b352-88d0e2a6d63d',
										number: '2.2.2.1.b)',
										name: 'Werbung mit Jugendlichen als DarstellerInnen oder Werbung, die sich an Jugendliche richtet, darf strafrechtlich relevante Darstellungen oder Aussagen nur dann beinhalten, wenn diese als eine Botschaft und Aufforderung zu rechtskonformen Verhalten zu verstehen ist.',
										isFromCodeOfEthics: true,
									},
									{
										id: '9377e2c6-9b07-40f7-bbd7-205ac738f4a7',
										number: '2.2.2.1.c)',
										name: 'Werbung für Produkte wie Tabak, Alkohol, Arzneimittel, Waffen, Nahrungsergänzungsmittel und Schlankheitspräparate darf sich nicht an die Zielgruppe der Jugendlichen wenden.',
										isFromCodeOfEthics: true,
									},
									{
										id: 'b7c8f9ad-7e87-4d5d-9671-80c6c8a6c292',
										number: '2.2.2.1.d)',
										name: 'Es darf keine Werbung darf für Schönheitsoperationen für unter 18-Jährige erfolgen.',
										isFromCodeOfEthics: true,
									},
									{
										id: 'a20f8be3-1b7e-4430-8370-b6e4aa7e28e0',
										number: '2.2.2.1.e)',
										name: 'Zum Schutz von Jugendlichen dürfen keine Darstellungen oder Aussagen erfolgen, die gesundheitsschädigendes Verhalten fördern könnten. Besonders im Hinblick auf Bulimie, Anorexie, Adipositas, etc. ist darauf zu achten, dass gesundheitlich bedenkliche Körperformen, insbesondere in Bezug auf das Körpergewicht, nicht dargestellt, aber auch nicht lächerlich gemacht werden.',
										isFromCodeOfEthics: true,
									},
									{
										id: 'fcbf6d6f-60bf-488e-b5aa-6a695b8d208b',
										number: '2.2.2.1.f)',
										name: 'Des Weiteren dürfen keine Darstellungen und Aussagen erfolgen, die ein überidealisiertes Gesamt-Erscheinungsbild (z.B.: Gesichtskorrekturen, Brustvergrößerungen, Übertrainiertheit) als anzustrebendes (Schönheits-)Ideal fördern könnten.',
										isFromCodeOfEthics: true,
									},
								],
							},
							{
								id: 'e4b1c2d3-6e64-4b9a-9340-8e5d7b4c6e9d',
								number: '2.2.2.2',
								name: 'Unangebrachte audiovisuelle kommerzielle Kommunikation für alkoholische Getränke im Umfeld von Jugendlichen',
								isFromCodeOfEthics: true,
								children: [
									{
										id: 'e61a9f70-8b78-4c4f-b3e7-51c7f0a2a4f7',
										number: '2.2.2.2.a)',
										name: 'Audiovisuelle kommerzielle Kommunikation für alkoholische Getränke darf Kinder und Jugendliche unter 18 Jahren weder zum Trinken von alkoholischen Getränken auffordern, noch trinkende bzw. zum Trinken auffordernde Jugendliche zeigen.',
										isFromCodeOfEthics: true,
									},
									{
										id: 'b3cfe73c-1a29-4ef6-bc70-25ab7f66b3ea',
										number: '2.2.2.2.b)',
										name: 'Audiovisuelle kommerzielle Kommunikation für alkoholische Getränke soll nicht in Medien erfolgen, deren redaktioneller Teil sich mehrheitlich an Jugendliche richtet.',
										isFromCodeOfEthics: true,
									},
									{
										id: 'd7a2d3a8-207d-492c-93ec-8e4e6273e615',
										number: '2.2.2.2.c)',
										name: 'Audiovisuelle kommerzielle Kommunikation für alkoholische Getränke soll keine Aussagen enthalten, in denen Jugendliche als noch nicht alt genug für den Konsum alkoholhaltiger Getränke angesprochen und dadurch zum Trinken provoziert werden',
										isFromCodeOfEthics: true,
									},
									{
										id: 'c1af76e8-8362-4318-8f12-56f2d87404c3',
										number: '2.2.2.2.d)',
										name: 'Audiovisuelle kommerzielle Kommunikation für alkoholische Getränke soll keine Personen darstellen, die aussagen, dass sie bereits als Jugendliche(r) alkoholische Getränke konsumiert haben.',
										isFromCodeOfEthics: true,
									},
									{
										id: 'e5a8838b-7da7-45b7-bcfc-520d6e8f3e5f',
										number: '2.2.2.2.e)',
										name: 'Werden Personen in audiovisueller kommerzieller Kommunikation für alkoholische Getränke gezeigt, müssen sie mindestens, auch vom optischen Eindruck her, junge Erwachsene sein.',
										isFromCodeOfEthics: true,
									},
								],
							},
						],
					},
				],
			},
			{
				id: 'd1b1a3f4-6e74-4b8a-9340-8e5d7c4b6e9d',
				number: '2.3',
				name: 'Ältere Menschen',
				isFromCodeOfEthics: true,
				children: [
					{
						id: 'c2b1a3d4-8e94-4b8a-9340-8e6d7b5c4e9d',
						number: '2.3.1',
						name: 'Jede diskriminierende Darstellung und verbale Äußerung über ältere Personen, besonders in Kombination mit Diskriminierung aufgrund des Geschlechts, ist zu vermeiden. Im Besonderen dürfen ältere Personen nicht vordergründig naiv, inkompetent oder lächerlich abgebildet werden.',
						isFromCodeOfEthics: true,
					},
					{
						id: 'd3a1b2c4-7e84-4b8a-9340-8e5d6c5b4e9d',
						number: '2.3.2',
						name: 'Ältere Menschen sind in der Darstellung nicht auf ihre Defizite zu reduzieren. Besonders bei einer vergleichenden Gegenüberstellung mit anderen Generationen ist sensibel vorzugehen.',
						isFromCodeOfEthics: true,
					},
					{
						id: 'e1b1a2d3-6e64-4b8a-9340-8e5d7c4b6e9d',
						number: '2.3.3',
						name: 'Bei der Darstellung von älteren Menschen in der Werbung ist stets auf einen würdevollen Umgang zu achten.',
						isFromCodeOfEthics: true,
					},
				],
			},
			{
				id: 'd2b1a3c4-8e94-4b8a-9340-8e5d7b4c6e9d',
				number: '2.4',
				name: 'Alkohol',
				isFromCodeOfEthics: true,
				children: [
					{
						id: 'c1a1b2d3-7e84-4b8a-9340-8e6d7c5b4e9d',
						number: '2.4.1',
						name: 'Werbung soll nicht zu übermäßigem oder missbräuchlichem Alkoholkonsum ermutigen.',
						isFromCodeOfEthics: true,
					},
					{
						id: 'd3a1b2c4-6e64-4b8a-9340-8e5d7b4c7e9d',
						number: '2.4.2',
						name: 'Alkoholwerbung soll sich nicht an die Zielgruppe Kinder wenden.',
						isFromCodeOfEthics: true,
					},
					{
						id: 'e4b1a2d3-8e94-4b8a-9340-8e6d7b5c4e9d',
						number: '2.4.3',
						name: 'Für Alkoholwerbung im Umfeld von Personen unter 18 Jahren gelten die Anforderungen des Kapitels 2.2.2.2.',
						isFromCodeOfEthics: true,
					},
					{
						id: 'c2b1a3f4-7e84-4b8a-9340-8e5d7c4b6e9d',
						number: '2.4.4',
						name: 'Werbung soll sich keiner verharmlosenden Darstellungen bedienen. Darstellungen wie z.B. das Lenken von Fahrzeugen oder das Bedienen von Maschinen im Zusammenhang von Alkoholkonsum sind zu vermeiden.',
						isFromCodeOfEthics: true,
					},
					{
						id: 'd4b1a2c3-6e64-4b8a-9340-8e5d7b4c8e9d',
						number: '2.4.5',
						name: 'Werbung soll nicht den Eindruck erwecken, Alkoholkonsum hätte therapeutische Wirkungen und könne mithelfen, private und soziale Probleme zu lösen.',
						isFromCodeOfEthics: true,
					},
					{
						id: 'e1a1b2d3-8e94-4b8a-9340-8e6d7c5b4e9d',
						number: '2.4.6',
						name: 'Für Bier und Spirituosen sind die speziellen Kriterien in den beiden Anhängen des Ethik-Kodex zu berücksichtigen.',
						isFromCodeOfEthics: true,
					},
				],
			},
			{
				id: 'd1b1a3c4-7e74-4b8a-9340-8e5d7c4b6e9d',
				number: '2.5',
				name: 'Tabak',
				isFromCodeOfEthics: true,
				children: [
					{
						id: 'c3b1a2d4-8e94-4b8a-9340-8e6d7c5b4e9d',
						number: '2.5.1',
						name: 'Tabakwerbung muss die vereinbarten Selbstbeschränkungsrichtlinien strikt beachten.',
						isFromCodeOfEthics: true,
					},
					{
						id: 'd4a1b2f3-7e84-4b8a-9340-8e5d6b4c7e9d',
						number: '2.5.2',
						name: 'Werbung soll Tabakkonsum weder verharmlosen noch durch Darstellungen bzw. Aussagen zum übermäßigen Konsum ermutigen.',
						isFromCodeOfEthics: true,
					},
					{
						id: 'e3a1b2c4-6e64-4b8a-9340-8e5d7b4c8e9d',
						number: '2.5.3',
						name: 'Tabakwerbung soll sich nicht an die Zielgruppe Kinder wenden.',
						isFromCodeOfEthics: true,
					},
					{
						id: '59385750-1ba0-420e-b3e4-3a1146c9e319',
						number: '2.5.4',
						name: 'Werbung soll nicht den Eindruck erwecken, Tabakkonsum steigere die soziale Akzeptanz.',
						isFromCodeOfEthics: true,
					},
					{
						id: 'd3b1a2f4-7e84-4b8a-9340-8e5d7c4b6e9d',
						number: '2.5.5',
						name: 'Tabakwerbung soll NichtraucherInnen nicht diskriminieren.',
						isFromCodeOfEthics: true,
					},
				],
			},
			{
				id: 'd2a1b3c4-8e94-4b8a-9340-8e6d7b4c6e9d',
				number: '2.6',
				name: 'Kraftfahrzeuge',
				isFromCodeOfEthics: true,
				children: [
					{
						id: 'c1a1b2d3-7e84-4b8a-9340-8e5d7c5b4e9d',
						number: '2.6.1',
						name: 'Werbung soll keine Fahrszenen darstellen, die nicht gesetzeskonform sind bzw. zu riskantem, aggressivem oder leichtsinnigem Fahren verleiten können.',
						isFromCodeOfEthics: true,
					},
					{
						id: 'd3b1a2c4-6e64-4b8a-9340-8e5d7b4c7e9d',
						number: '2.6.2',
						name: 'Schnelligkeit, hohe Beschleunigung bzw. Motorleistung sollen nicht die dominierenden Aussagen der Werbebotschaft sein.',
						isFromCodeOfEthics: true,
					},
					{
						id: 'e4b1a2d3-8e94-4b8a-9340-8e6d7c5b4e9d',
						number: '2.6.3',
						name: 'Das Hervorheben besonderer technischer Eigenschaften des Fahrzeuges oder des Zubehörs (insbesondere Sicherheitstechnik) soll nicht zu der Annahme verleiten, damit jede gefährliche Situation im Straßenverkehr meistern zu können und so zu risikoreichem Fahren ermutigen.',
						isFromCodeOfEthics: true,
					},
					{
						id: 'c2b1a3d4-7e74-4b8a-9340-8e5d7c4b6e9d',
						number: '2.6.4',
						name: 'Werbung soll kein energievergeudendes und umweltschädliches Fahrverhalten propagieren.',
						isFromCodeOfEthics: true,
					},
				],
			},
		],
	},
	{
		id: '1f8ac10d-5c3c-4373-bbce-3b5e849d4f47',
		number: '10',
		name: 'Ethik & Moral',
		isFromCodeOfEthics: false,
	},
	{
		id: '2a5a8e65-d8ec-4015-9518-88c0e4c6e71a',
		number: '11',
		name: 'Gewalt',
		isFromCodeOfEthics: false,
	},
	{
		id: '3e94df63-410b-431f-92be-9bbdf8a59b2d',
		number: '12',
		name: 'Gesundheit',
		isFromCodeOfEthics: false,
	},
	{
		id: '4cb8f10c-80e3-44f7-88c5-4d1b48f58d6e',
		number: '13',
		name: 'Sicherheit',
		isFromCodeOfEthics: false,
	},
	{
		id: '59bdbf6b-9e8a-4c7f-b4e1-8a5b1f3f927a',
		number: '14',
		name: 'Umwelt',
		isFromCodeOfEthics: false,
	},
	{
		id: '6f5dffbe-19d6-4b59-9c65-2c5ab4e9874d',
		number: '15',
		name: 'Verletzung von religiösen Gefühlen',
		isFromCodeOfEthics: false,
	},
	{
		id: '7f8bc80a-dfb1-46d3-8f7d-b5e4d15a7b24',
		number: '16',
		name: 'Rechtswidriges Werbeumfeld',
		isFromCodeOfEthics: false,
	},
	{
		id: '8ccead95-2ebf-42af-a59e-d23fb2a3ea7f',
		number: '17',
		name: 'Geschlechterdiskriminierende Werbung',
		isFromCodeOfEthics: false,
	},
	{
		id: '9fd9e6d7-2af8-4974-9a6d-2f1c5b45d6b3',
		number: '18',
		name: 'Gefährdung von Kindern und Jugendlichen',
		isFromCodeOfEthics: false,
	},
	{
		id: 'a6b3a740-cf49-4a62-a6a5-5e658b1d5f5a',
		number: '19',
		name: 'Werbung mit Kindern und Jugendlichen',
		isFromCodeOfEthics: false,
	},
	{
		id: 'b5b6adf3-750b-4b60-9c8a-6f1a5d44d0fa',
		number: '20',
		name: 'Diskriminierung älterer Menschen',
		isFromCodeOfEthics: false,
	},
	{
		id: 'c0b8d197-7e0c-4b4a-a1c7-9e8bbf2b2e6c',
		number: '21',
		name: 'Diskriminierung aufgrund sexueller Orientierung',
		isFromCodeOfEthics: false,
	},
	{
		id: 'd3b8b3cf-14c8-4b6a-a872-2e6a8f5d7e71',
		number: '22',
		name: 'Diskriminierung aufgrund Behinderung/Beeinträchtigung',
		isFromCodeOfEthics: false,
	},
	{
		id: 'e0f8a40e-2d93-4eb5-8a35-9e3ab8f4b6e3',
		number: '23',
		name: 'Rassismus',
		isFromCodeOfEthics: false,
	},
	{
		id: 'f7b8c5d2-3b8d-4a5d-b6d2-3e4a8b2c7e2a',
		number: '24',
		name: 'Alkohol',
		isFromCodeOfEthics: false,
	},
	{
		id: 'f966afe8-d8bc-4b1e-8bb3-fe662d124fe7',
		number: '25',
		name: 'Nikotinprodukte',
		isFromCodeOfEthics: false,
	},
	{
		id: '425e1f44-63f5-4c64-b2c0-310217806cdb',
		number: '26',
		name: 'Kraftfahrzeuge und andere Fortbewegungsmittel',
		isFromCodeOfEthics: false,
	},
	{
		id: '35526954-40e5-406c-91a5-33a63652c8a7',
		number: '27',
		name: 'Irreführung und Täuschung',
		isFromCodeOfEthics: false,
	},
	{
		id: '51db4935-b241-4d7c-bb51-4b40e0b1453d',
		number: '28',
		name: 'Unlauterer Wettbewerb',
		isFromCodeOfEthics: false,
	},
	{
		id: 'f1b52ec5-547f-4812-ab1b-782374205cb9',
		number: '29',
		name: 'Herabwürdigung von PolitikerInnen',
		isFromCodeOfEthics: false,
	},
	{
		id: 'dbc7a2d6-ca27-4f6b-9fb9-7192c9b11724',
		number: '30',
		name: 'Tierschutz',
		isFromCodeOfEthics: false,
	},
];
